import React from 'react'

function WhyChoseUs() {
  return (
    <section class="wrapper custom-wrapper about-wrapper wh-text">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h2 class="block-title">Why Chose Techno Web Solutions</h2>
                    <p class="text-300">Techno Web Solutions offers a wide range of services in the field of design , development programming , web applications , SEO and marketing of your website . We offer the best solutions and best price for your business and impartial advice at an honest price .We research, analysis and investigating the best technologies and recommended them to our clients. We believe honesty and quality work. We respect our clients most and always give our best to them, we value their every penny. Simply if you give us a chance to work for you then you will be remain satisfied with the result and care we provide.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <ul class="list-unstyled services-list why-chose hi-icon-effect-8">
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe012;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>12 years of Excellence</h3>
                            <p>With 12 years of quality services, on-time delivery and best customer support</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe029;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>High Quality performance</h3>
                            <p>Our products maintain high quality performance to reach client satisfaction</p>
                        </div>
                    </li>               
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe018;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Competitive Price</h3>
                            <p>We provide the best competitive price for our services . We value your money and time</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe106;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Client Satisfaction</h3>
                            <p>Respect our clients and give best services as client satisfaction is our most priority</p>
                        </div>
                    </li>
                            <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe0f5;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Innovative strategy</h3>
                            <p>We innovative our strategies to meet our clients need and performed to build new landmarks in business</p>
                        </div>
                    </li>
                    </ul>
                </div>
                <div class="col-md-4 col-sm-6">
                    <ul class="list-unstyled services-list why-chose hi-icon-effect-8">
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe08b;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Highly Skilled Team</h3>
                            <p>We poses very high skilled, Certified and Experience team to perform all the task</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe0f6;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Impenetrable security</h3>
                            <p>Web Development & Applications give your business safety with impenetrable security</p>
                        </div>
                    </li>               
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe028;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>24/7 customer support</h3>
                            <p>Provide 24x7 supports to all of our clients for any inquiries that may find solutions</p>
                        </div>
                    </li>
                    <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe032;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Customer reviews</h3>
                            <p>Happy customers is our inspiration and we just had to share it through there reviews</p>
                        </div>
                    </li>
                            <li>
                        <div class="service-icon hi-icon glyph">
                            <div data-icon="&#xe0f0;" aria-hidden="true"></div>
                        </div>
                        <div class="service-des">
                            <h3>Empowering business</h3>
                            <p>We Empower business by making innovative approach and create best profitable business for our clients</p>
                        </div>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="side-image why-chose-img"><img class="img-responsive" alt="" src="assets/images/side-img-1.png" /> </div>
    </section>
  )
}

export default WhyChoseUs